/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { BulkUpdateVisitsErrorReasonEnumType } from "./BulkUpdateVisitsErrorReasonEnum"
import { RootStoreType } from "./index"


/**
 * BulkUpdateVisitsErrorDtoBase
 * auto generated base class for the model BulkUpdateVisitsErrorDtoModel.
 */
export const BulkUpdateVisitsErrorDtoModelBase = ModelBase
  .named('BulkUpdateVisitsErrorDto')
  .props({
    __typename: types.optional(types.literal("BulkUpdateVisitsErrorDto"), "BulkUpdateVisitsErrorDto"),
    uuid: types.union(types.undefined, types.string),
    eventUuid: types.union(types.undefined, types.null, types.string),
    reason: types.union(types.undefined, BulkUpdateVisitsErrorReasonEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BulkUpdateVisitsErrorDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromBulkUpdateVisitsErrorDto() {
  return new BulkUpdateVisitsErrorDtoModelSelector()
}

export const bulkUpdateVisitsErrorDtoModelPrimitives = selectFromBulkUpdateVisitsErrorDto().uuid.eventUuid.reason
